<template>
  <div>
    <v-stepper v-model="currentStep" :elevation="0">
      <v-stepper-items>
        <v-stepper-content
          v-for="(step, index) in possibleSteps"
          :key="index + 1"
          :step="index + 1"
        >
          <component
            :is="step.settings.cmp"
            v-if="step.type === 'static'"
            :error-scroll-container="errorScrollContainer"
            :form-name="formName"
            v-bind="{
              ...step.settings.props,
              storePath: step.dialogDataStore
            }"
            @next-click="$emit('next-click')"
            @prev-click="$emit('prev-click')"
            @close="$emit('close')"
          />
          <DynamicFormStep
            v-else
            :step="step.settings"
            :step-id="index"
            :form-name="formName"
            :gtm-form-name="gtmFormName"
            :error-scroll-container="errorScrollContainer"
            :is-last-step="index === possibleSteps.length"
            :is-sending="isSending"
            :use-old-gtm="useOldGtm"
            :is-dialog="isDialog"
            @next-click="$emit('next-click')"
            @prev-click="$emit('prev-click')"
            @close="$emit('close')"
          />
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
  </div>
</template>

<script>
import dynamicForms from '@/mixins/dynamicForms';
import TallyInfoStep from '@/components/Forms/Tally/TallyInfoStep';
import IframeStep from '@/components/Forms/IframeStep';
import VideoTherapyInfoStep from '@/components/Forms/VideoTherapy/VideoTherapyInfoStep';
import VideoTherapyFormStep from '@/components/Forms/VideoTherapy/VideoTherapyFormStep';
import VideoCallCalendar from '@/components/Forms/VideoCall/VideoCallCalendar';
import VideoCallThankYou from '@/components/Forms/VideoCall/VideoCallThankYou';
import BloodTestInfoStep from '@/components/Atoms/BloodTestInfoStep';
import VideoCallInfoStep from '@/components/Forms/VideoCall/VideoCallInfoStep';
import VideoCallFormStep from '@/components/Forms/VideoCall/VideoCallFormStep';
import PhoneVerification from '@/components/Molecules/PhoneVerification';

export default {
  name: 'DynamicForm',
  components: {
    TallyInfoStep,
    IframeStep,
    VideoTherapyInfoStep,
    VideoTherapyFormStep,
    VideoCallCalendar,
    VideoCallThankYou,
    BloodTestInfoStep,
    VideoCallInfoStep,
    VideoCallFormStep,
    PhoneVerification
  },
  mixins: [dynamicForms],
  props: {
    formName: {
      type: String,
      required: true
    },
    errorScrollContainer: {
      type: String,
      default: 'body'
    },
    // TODO: upravit aby to bylo generické
    useOldGtm: {
      type: Boolean,
      default: false
    },
    gtmFormName: {
      type: String,
      required: false
    },
    isSending: {
      type: Boolean,
      required: true
    },
    isDialog: {
      type: Boolean,
      required: true
    }
  }
};
</script>
